import { createSelector } from 'reselect';
import WarningMessage from '@Selectors/builder/myArmyList/make/unit/edit/warning/WarningMessage';
import { checkContraints } from '@Selectors/builder/myArmyList/make/validation/check-contraints';
import { constrainedOjectsPresenter } from '@Selectors/builder/myArmyList/make/validation/constrained-objects.presenter';
import { selectedElementsPresenter } from '@Selectors/builder/myArmyList/make/validation/selected-elements.presenter';

export const checkContraintsPresenter = createSelector(
  [constrainedOjectsPresenter, selectedElementsPresenter],
  (elements, selecteds): WarningMessage[] => {
    return checkContraints(elements, selecteds);
  },
);
